function fadeInDebossing(el, duration) {
  if (!el) return;
  el.style.opacity = 0;
  el.style.display = 'block';
  var start = performance.now();
  requestAnimationFrame(function animate(time) {
    var elapsed = time - start;
    var progress = Math.min(elapsed / (duration || 500), 1);
    el.style.opacity = progress;
    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  });
}

function fadeOutDebossing(el, duration) {
  if (!el) return;
  var start = performance.now();
  var initialOpacity = parseFloat(el.style.opacity) || 1;
  requestAnimationFrame(function animate(time) {
    var elapsed = time - start;
    var progress = Math.min(elapsed / (duration || 500), 1);
    el.style.opacity = initialOpacity * (1 - progress);
    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      el.style.display = 'none';
    }
  });
}

function updateDebossingPopupVariantImage() {
  try {
    var mapScript = document.getElementById('debossing-variant-images-map');
    if (!mapScript) return;
    var data = JSON.parse(mapScript.innerHTML || '{}');

    var activeVariantId = null;
    var activeInput = document.querySelector('input[name="id"]:not([disabled]), select[name="id"]');
    if (activeInput) {
      activeVariantId = activeInput.value;
    }
    if (!activeVariantId) {
      var urlParams = new URLSearchParams(window.location.search);
      activeVariantId = urlParams.get('variant');
    }

    var activeColor = null;
    var colorInput = document.querySelector('input[name*="Color"]:checked, input[name*="color"]:checked, input[name*="Option"]:checked');
    if (colorInput) {
      activeColor = colorInput.value;
    }
    if (!activeColor) {
      var selVal = document.querySelector('.selected-value, [data-option-name="Color"] .active, .product-form__input--color input:checked');
      if (selVal) {
        activeColor = selVal.value || selVal.textContent.trim();
      }
    }

    var targetImgSrc = "";
    var matchingDebossingVariantId = null;

    if (data.debossing_variants && activeColor) {
      Object.keys(data.debossing_variants).forEach(function(id) {
        var v = data.debossing_variants[id];
        if (v.title && (v.title.toLowerCase() === activeColor.toLowerCase() || (v.option1 && v.option1.toLowerCase() === activeColor.toLowerCase()))) {
          matchingDebossingVariantId = v.id;
          if (v.img) {
            targetImgSrc = v.img;
          }
        }
      });
    }

    if (!targetImgSrc && activeVariantId && data.product_variants && data.product_variants[activeVariantId]) {
      var pVar = data.product_variants[activeVariantId];
      if (pVar.img) {
        targetImgSrc = pVar.img;
      }
    }

    if (!targetImgSrc && activeColor && data.product_variants) {
      Object.keys(data.product_variants).forEach(function(id) {
        var v = data.product_variants[id];
        if (v.title && (v.title.toLowerCase().indexOf(activeColor.toLowerCase()) > -1 || (v.option1 && v.option1.toLowerCase() === activeColor.toLowerCase()))) {
          if (v.img) {
            targetImgSrc = v.img;
          }
        }
      });
    }

    if (targetImgSrc) {
      var imgEl = document.querySelector('.debossing_popup .gift-card-second-img img');
      if (imgEl) imgEl.setAttribute('src', targetImgSrc);
    }

    if (matchingDebossingVariantId) {
      var variantInput = document.querySelector('input.debossing_line_item:not(.additonal_text)');
      if (variantInput) variantInput.value = matchingDebossingVariantId;

      var removeBtn = document.getElementById('remove_from_cart_debossing');
      if (removeBtn) removeBtn.setAttribute('product-id', matchingDebossingVariantId);
    }
  } catch(err) {
  }
}

function initDebossingPopup() {
  updateDebossingPopupVariantImage();

  // Color change reload handler
  document.querySelectorAll('input[name="Color"]').forEach(function(radio) {
    radio.addEventListener("change", function () {
      setTimeout(function () {
        location.reload();
      }, 20);
    });
  });

  // Listen for variant or color changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="id"], select[name="id"], input[name*="Color"], input[name*="color"], input[name*="Option"]')) {
      updateDebossingPopupVariantImage();
    }
  });

  // Handle click interactions
  document.addEventListener('click', function(e) {
    // Hide product type list if modal content clicked
    if (e.target.closest('.gift-card-popup__content')) {
      var typeList = document.getElementById('product-type-list');
      if (typeList) typeList.style.display = 'none';
    }

    // Open Debossing Modal trigger
    var openTrigger = e.target.closest('.gift_card_button-text.debossing_card_button-text, .CP-debossing-CTA');
    if (openTrigger) {
      e.stopPropagation();
      updateDebossingPopupVariantImage();
      document.body.classList.add('gift-card-popup-open');
      var popup = document.querySelector('.gift-card-popup.debossing_popup');
      if (popup) fadeInDebossing(popup, 500);
      var debossingCard = document.querySelector('.gift_card_product.debossing-card');
      if (debossingCard) debossingCard.classList.add('added_item');
    }

    // Close Debossing Modal button
    var closeTrigger = e.target.closest('.debossing_popup .gift-card-close');
    if (closeTrigger) {
      var popup = document.querySelector('.gift-card-popup.debossing_popup');
      if (popup) fadeOutDebossing(popup, 500);
      document.body.classList.remove('gift-card-popup-open');
      var textInput = document.querySelector('input.debossing_line_item.additonal_text');
      if (!textInput || !textInput.value) {
        var debossingCard = document.querySelector('.gift_card_product.debossing-card');
        if (debossingCard) debossingCard.classList.remove('added_item');
      }
    }

    // Click outside Debossing Modal content to close
    var debossingPopup = document.querySelector('.gift-card-popup.debossing_popup');
    if (debossingPopup && debossingPopup.contains(e.target) && !e.target.closest('.gift-card-popup__content')) {
      fadeOutDebossing(debossingPopup, 500);
      document.body.classList.remove('gift-card-popup-open');
      var textInput = document.querySelector('input.debossing_line_item.additonal_text');
      if (!textInput || !textInput.value) {
        var debossingCard = document.querySelector('.gift_card_product.debossing-card');
        if (debossingCard) debossingCard.classList.remove('added_item');
      }
    }

    // Add debossing initials button inside popup
    var addBtn = e.target.closest('.gift-add-to-cart-btn.debossing_add_btn');
    if (addBtn) {
      var debossingInput = document.querySelector('.debossing_text_val');
      if (!debossingInput) return;
      var debossingText = debossingInput.value ? debossingInput.value.trim().toUpperCase() : "";
      var errorMsg = document.getElementById('initials-error');

      if (debossingText.length === 0) {
        if (errorMsg) errorMsg.style.display = 'block';
        return;
      } else {
        if (errorMsg) errorMsg.style.display = 'none';
        var lineItemInput = document.querySelector('input.debossing_line_item.additonal_text');
        if (lineItemInput) lineItemInput.value = debossingText;

        updateDebossingPopupVariantImage();

        var removeBtn = document.getElementById('remove_from_cart_debossing');
        if (removeBtn) {
          var debossingVariantId = removeBtn.getAttribute('product-id');
          if (debossingVariantId) {
            var variantInput = document.querySelector('input.debossing_line_item:not(.additonal_text)');
            if (variantInput) variantInput.value = debossingVariantId;
          }
        }

        document.querySelectorAll('.debossing_line_item').forEach(function(item) {
          item.removeAttribute('disabled');
        });
      }

      var popup = document.querySelector('.gift-card-popup.debossing_popup');
      if (popup) fadeOutDebossing(popup, 500);
      document.body.classList.remove('gift-card-popup-open');

      document.querySelectorAll('.gift-card-added-text.debossing_added_text').forEach(function(el) {
        el.style.setProperty('display', 'flex', 'important');
      });
      var debossingCard = document.querySelector('.gift_card_product.debossing-card');
      if (debossingCard) debossingCard.classList.add('added_item');
    }

    // Product dropdown toggle inside modal
    var firstContent = e.target.closest('.gift-card-first-content:not(.father_product)');
    if (firstContent) {
      e.stopPropagation();
      firstContent.classList.add('open-list');
      var typeList = document.getElementById('product-type-list');
      if (typeList) typeList.style.display = 'block';
    }

    var itemSelect = e.target.closest('#product-type-list li.product-item');
    if (itemSelect) {
      var wrapper = document.querySelector('.gift-pro-list-first .gift-card-first-content .gift-ul-wrapper');
      if (wrapper) wrapper.innerHTML = itemSelect.outerHTML;
      var typeList = document.getElementById('product-type-list');
      if (typeList) typeList.style.display = 'none';
      var firstCont = document.querySelector('.gift-card-first-content');
      if (firstCont) firstCont.classList.remove('open-list');
    }
  });

  // Remove debossing button click (touch and click)
  ['click', 'touchstart'].forEach(function(evtName) {
    document.addEventListener(evtName, function(e) {
      var removeBtn = e.target.closest('#remove_from_cart_debossing, .CP-debossing-CTA-pdp-alignment-remove');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();

        document.querySelectorAll('.gift-card-added-text.debossing_added_text').forEach(function(el) {
          el.style.setProperty('display', 'none', 'important');
        });

        var debossingCard = document.querySelector('.gift_card_product.debossing-card');
        if (debossingCard) debossingCard.classList.remove('added_item');

        var debossingInput = document.querySelector('input.debossing_text_val');
        if (debossingInput) debossingInput.value = '';

        var lineItemInput = document.querySelector('input.debossing_line_item.additonal_text');
        if (lineItemInput) lineItemInput.value = '';

        document.querySelectorAll('.debossing_line_item').forEach(function(item) {
          item.setAttribute('disabled', 'disabled');
        });
      }
    });
  });

  // Initials input formatting
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('debossing_text_val')) {
      var upperVal = e.target.value.toUpperCase();
      if (upperVal.length > 2) {
        upperVal = upperVal.substring(0, 2);
      }
      e.target.value = upperVal;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDebossingPopup);
} else {
  initDebossingPopup();
}
